<h2 class="alt">{{ picture.name }}</h2>
<div class="gallery">
    <a target="_blank" [href]="picture.image">
        <img [src]="picture.imageLow" [alt]="picture.name">
    </a>
    <div class="desc">{{ picture.description }}</div>
</div>
